import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MileageComponent } from './mileage/mileage.component';


const routes: Routes = [{
  path: '',
  component: MileageComponent,
  data: { title: null }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MileageRoutingModule { }
